import { render } from "./PoliticaPrivacidad.vue?vue&type=template&id=2a25d47c&scoped=true"
import script from "./PoliticaPrivacidad.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidad.vue?vue&type=script&lang=js"

import "./PoliticaPrivacidad.vue?vue&type=style&index=0&id=2a25d47c&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a25d47c"]])

export default __exports__